import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { environment } from '../../environments/environment';
import { Observable, shareReplay } from 'rxjs';
import { GlobalConstants } from '../common/global';
import { CountriesResponse } from '../common/countries.model';
import { RegistrationResponse } from '../common/interfaces';
import { FormDataStoreService } from './form-data.store';
import { GdprSubscriptionsService } from "./gdpr-subscriptions.service";

@Injectable({
  providedIn: 'root'
})

export class Services {
  eventList: any;
  state$ = new BehaviorSubject<any>(null);
  deliverySubscriptionWithMemberData: any;

  constructor(private httpClient: HttpClient, private readonly formDataStore: FormDataStoreService, private readonly gdprSubscriptionsService: GdprSubscriptionsService) { }

  logout() {
    localStorage.removeItem('accessToken' + environment.connId);
    localStorage.removeItem('accessTokenCentral' + environment.connId);
    localStorage.removeItem('orderId');
    localStorage.removeItem('orderIdEventId');
    localStorage.removeItem('cardType');
    localStorage.removeItem('sector');
    localStorage.removeItem('group');
    localStorage.removeItem('ticketNumber');
    this.formDataStore.clearAllFormData();
    this.gdprSubscriptionsService.clear();
    window.location.reload();
  }

  getUserGdpr() {
    return this.httpClient.get(`${environment.apiUrl}/v1/main/user/gdpr`)
  }

  postUserGdpr(body:any) {
    return this.httpClient.post(`${environment.apiUrl}/v1/main/user/gdpr`, body, GlobalConstants.headers)
  }

  registerUser(body:any, headers:object): Observable<RegistrationResponse> {
    return this.httpClient.post<RegistrationResponse>(`${environment.apiUrl}/v1/main/user/profile`, body, headers);
  }

  registerUserMember(body:any, headers:object) {
    return this.httpClient.post(`${environment.apiUrl}/v1/main/user/profile2`, body, headers);
  }

  updateProfile(profileID:number, updateProfileForm:any) {
    return this.httpClient.patch<any>(`${environment.apiUrl}/v1/profiles/4369?profileType=KUPAC`, updateProfileForm )
  }

  getAllEvents() {
    return this.httpClient.get(`${environment.apiUrl}/v1/main/events?connId=${environment.connId}`);
  }

  getEventDetailsApi(connId:number, eventId:number, actionId:number) {
    return this.httpClient.get(`${environment.apiUrl}/conn/${connId}/v1/events/${eventId}/${actionId}`);
  }

  refreshToken() {
    const httpOptions = {
      withCredentials: true,
    };

    this.httpClient.post<any>(`${environment.apiUrl}/auth/main/refresh`, {}, httpOptions ).subscribe({
      next: data => {
        localStorage.setItem('accessToken' + environment.connId, data.accessToken);
      },
      error: error => {
      }
    })
  }

  cancelOrder(orderId:any, reloadPage: boolean, newUrl: any, transactionExpired: boolean = false) {
    return this.httpClient.delete<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${orderId}`, GlobalConstants.headersCentral ).subscribe({
      next: data => {
        window.localStorage.removeItem('orderId');
        window.localStorage.removeItem('orderIdEventId');
        window.localStorage.removeItem('orderInfo');
        sessionStorage.removeItem("orderInfoRemainingTimeToPay");

        if (transactionExpired) {
          window.location.href = window.location.href.replace(/\/$/, '') + '/transactionExpired';
        } else {
          document.location = window.location.href;
        }
      },
      error: error => {
        document.location = window.location.href;
      }
    })
  }

  getListOfCountries(): Observable<CountriesResponse> {
    const url = `${environment.apiUrl}/v1/main/countries`;
    return this.httpClient.get<CountriesResponse>(url);
  }

  onSubmitConnectMembershipService(body: any): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/link`, body, GlobalConstants.headersCentral);
  }

  onSubmitConnectOtherMembershipService(body: any, isClubFriend: boolean): Observable<any> {
    const suffix = isClubFriend ? '2' : '';
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/link/others${suffix}`, body, GlobalConstants.headersCentral);
  }

  getListForVotingService(): Observable<any> {
    return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/anketa`, GlobalConstants.headersCentral);
  }

  submitSelectedListService(optId: any, listIdOption: string): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/anketa?optId=${optId}&fp=${listIdOption}`, null,GlobalConstants.headersCentral);
  }

  getMembersRightToVoteService(): Observable<any> {
    return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/anketa/memberRights`, GlobalConstants.headersCentral);
  }

  sendVerificationPIN(): Observable<any> {
    return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/anketa/2fa`, GlobalConstants.headersCentral);
  }

  checkVerificationPIN(code: any): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/anketa/2fa?code=${code}`, null, GlobalConstants.headersCentral);
  }

  sendImageService(body: any): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/anketa/doc`, body, GlobalConstants.headersCentral);
  }

  getIsVotingActiveService(): Observable<any> {
    return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/anketa/status`, GlobalConstants.headersCentral);
  }

  getPdfTicketsFromEmail(t: any, b: any, id: any, isTicketDelegation: boolean): Observable<any> {
    if(isTicketDelegation) {
      return this.httpClient.get<any>(`${environment.apiUrl}/v1/main/user/transactions/${t}/${b}/tickets-delegation/${id}`);
    } else {
      return this.httpClient.get<any>(`${environment.apiUrl}/v1/main/user/transactions/${t}/${b}/tickets/${id}`);
    }
  }

  getGdprForUpdatePhotoMembership(): Observable<any> {
    return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/updatePhotoMembershipGdpr`, GlobalConstants.headersCentral);
  }

  updatePhotoMembership(body: any, profileIdMember: number): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/updatePhotoMembershipGdpr/${profileIdMember}`, body, GlobalConstants.headersCentral);
  }

  getGroupDetailsService(barcode: any, birthDate: any): Observable<any> {
    return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/groupItems/${barcode}?date=${birthDate}`, GlobalConstants.headersCentral);
  }

  delGroupDetailService(body: any) {
    return this.httpClient.delete<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/groupItems/${body.barcode}/${body.id}`, GlobalConstants.headersCentral);
  }

  checkBarcodeService(barcode: any, seasonTicketExclusive: boolean): Observable<any> {
    if(seasonTicketExclusive) {
      return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/groups/getSubscriberData/${barcode}`, GlobalConstants.headersCentral);
    } else {
      return this.httpClient.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/getMemberData/${barcode}`, GlobalConstants.headersCentral);
    }
  }

  updateMembersProfileService(body: any, orderId: any): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${orderId}/guests-and-members`, body, GlobalConstants.headersCentral);
  }

  connectSeasonTicketService(body: any, connectionType: string): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/groups/link${connectionType}`, body, GlobalConstants.headersCentral);
  }

  autoRenewalMembershipService(transId: any, flag: boolean): Observable<any> {
    return this.httpClient.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/autoRenewal/${transId}?flag=${flag}`, {}, GlobalConstants.headersCentral);
  }

  removeItemFromOrder(orderId: any, itemId: any): Observable<any> {
    return this.httpClient.delete<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${orderId}/${itemId}`, GlobalConstants.headersCentral);
  }

deliverySubscriptionWithMember(orderId: number): Observable<any> {
  if (!this.deliverySubscriptionWithMemberData) {
    this.deliverySubscriptionWithMemberData = this.httpClient.get<any>(
      `${environment.apiUrl}/conn/${environment.connId}/v1/orders/${orderId}/deliverySubscriptionWithMember`,
      GlobalConstants.headersCentral
    ).pipe(
      shareReplay(1)
    );
  }
  return this.deliverySubscriptionWithMemberData;
}
}
